import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/DashboardLayout.css';
import citadelLogo from '../../assets/citadelogo.png';

const navLinks = [
  { to: '/dashboard', label: 'Dashboard', icon: '🏠' },
  { to: '/dashboard/messages', label: 'Communication', icon: '💬' },
  { to: '/dashboard/files', label: 'File Sharing', icon: '📁' },
  { to: '/dashboard/staff', label: 'Staff Management', icon: '👥' },
  { to: '/dashboard/patients', label: 'Patient Management', icon: '🧑‍⚕️' },
   { to: '/dashboard/m365', label: 'M365 Management', icon: '🛠️', adminOnly: true },
];

const DashboardLayout = ({ children, pageTitle }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const userRole = localStorage.getItem('userRole');


  // Hamburger icon
  const Hamburger = (
    <button
      className="hamburger"
      aria-label="Open sidebar menu"
      onClick={() => setSidebarOpen(true)}
    >
      <span className="hamburger-bar"></span>
      <span className="hamburger-bar"></span>
      <span className="hamburger-bar"></span>
    </button>
  );

  // Close (X) icon for sidebar
  const CloseBtn = (
    <button
      className="sidebar-close"
      aria-label="Close sidebar menu"
      onClick={() => setSidebarOpen(false)}
    >
      &times;
    </button>
  );

  // Overlay for sidebar on mobile
  const SidebarOverlay = (
    <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>
  );

  return (
    <div className="dashboard-root">
      <aside className={`sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="sidebar-header">
          <img src={citadelLogo} alt="Citadel of Grace Logo" className="clinic-logo" />
          {CloseBtn}
        </div>
        <ul className="sidebar-nav">
          {navLinks.map(link => {
            if (link.to === '/dashboard/staff' && userRole !== 'admin') {
              return null;
            }
            return (
              <li key={link.to} className={location.pathname === link.to ? 'active' : ''}>
                <Link to={link.to} onClick={() => setSidebarOpen(false)}>
                  <span className="sidebar-icon">{link.icon}</span>
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>
        <button className="logout-btn" onClick={() => {
          localStorage.clear();
          window.location.href = '/login';
        }}>Logout</button>
      </aside>
      {/* Show overlay when sidebar is open on mobile */}
      {sidebarOpen && SidebarOverlay}
      <main className="main-content">
        <header className="main-header">
          {/* Hamburger in header for mobile */}
          {Hamburger}
          <h1>{pageTitle}</h1>
          <div className="header-actions">
          </div>
        </header>
        <div className="page-content">{children}</div>
      </main>
    </div>
  );
};

export default DashboardLayout; 